'use client';

import { useState } from 'react';

import { Box, Container } from '@mui/material';

import { CustomerElearning } from 'src/sections/landing/components/customer-elearning';
import { CenterRegisterForm } from 'src/sections/landing/components/center-register-form';
import { TestimonialElearning } from 'src/sections/landing/components/testimonial-elearning';

import { IntroTaskManage } from '../components/intro-task-manage';
import { DetailTaskManageFunction } from '../components/detail-task-manage-function';
import { StartWithCenterUpTaskManage } from '../components/start-with-center-up-task-manage';

export const TaskManageView = () => {
  const [openDemo, setOpenDemo] = useState<boolean>(false);
  return (
    <Box sx={{ overflowX: 'hidden', width: 1 }}>
      <Container>
        <IntroTaskManage setOpenDemoForm={() => setOpenDemo(true)} />
        <CustomerElearning />
        <DetailTaskManageFunction />
      </Container>
      <TestimonialElearning />
      <Container>
        <StartWithCenterUpTaskManage setOpenDemoForm={() => setOpenDemo(true)} />
      </Container>
      {openDemo && <CenterRegisterForm open={openDemo} onClose={() => setOpenDemo(false)} />}
    </Box>
  );
};
